import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Search, Bell } from "lucide-react";
import api from "@/lib/api";

export function TopBar({ greeting, name }) {
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    api.get("/notifications").then(({ data }) => setUnread(data.unread)).catch(() => {});
  }, []);
  return (
    <header className="sticky top-0 z-30 flex items-center justify-between border-b border-gray-100 bg-white/85 px-4 py-3 backdrop-blur-xl">
      <div>
        <p className="text-xs font-semibold uppercase tracking-widest text-brand">{greeting || "FlatTribe"}</p>
        <h1 className="font-heading text-2xl font-extrabold leading-tight tracking-tight text-ink">{name || "Find your tribe"}</h1>
      </div>
      <div className="flex items-center gap-2">
        <button data-testid="topbar-search" onClick={() => navigate("/search")} className="grid h-10 w-10 place-items-center rounded-full bg-secondary text-ink transition-transform active:scale-90">
          <Search className="h-5 w-5" />
        </button>
        <button data-testid="topbar-notifications" onClick={() => navigate("/notifications")} className="relative grid h-10 w-10 place-items-center rounded-full bg-secondary text-ink transition-transform active:scale-90">
          <Bell className="h-5 w-5" />
          {unread > 0 && <span className="absolute right-1.5 top-1.5 h-2.5 w-2.5 rounded-full bg-brand ring-2 ring-white" />}
        </button>
      </div>
    </header>
  );
}

export function BackHeader({ title, right }) {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-30 flex items-center gap-3 border-b border-gray-100 bg-white/90 px-3 py-3 backdrop-blur-xl">
      <button data-testid="back-button" onClick={() => navigate(-1)} className="grid h-10 w-10 place-items-center rounded-full bg-secondary text-ink transition-transform active:scale-90">
        <ArrowLeft className="h-5 w-5" />
      </button>
      <h1 className="flex-1 truncate font-heading text-lg font-extrabold text-ink">{title}</h1>
      {right}
    </header>
  );
}
